module.exports = __webpack_public_path__ + "img/btn-download@2x.36835fdf.png";